import React from 'react'

interface IconProps {
  color?: string
  size?: number
  className?: string
}

export const BankIcon: React.FC<IconProps> = ({
  color = '#fff',
  size = 28,
  className,
  ...rest
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 28 28"
    fill="none"
    className={className}
    {...rest}
  >
    <g
      opacity={color ? 1 : 0.4}
      fillRule="evenodd"
      clipRule="evenodd"
      fill={color}
    >
      <path d="M15.055 3.101a1.522 1.522 0 00-1.601-.017L2.822 9.515a1.015 1.015 0 00.525 1.883h1.521v11.67H3.44a.6.6 0 00-.6.6v.828a.6.6 0 00.6.6h21.12a.6.6 0 00.6-.6v-.83a.6.6 0 00-.6-.6h-1.43V11.4h1.522a1.015 1.015 0 00.544-1.873L15.056 3.101zm6.102 6.269l-6.922-4.387L6.983 9.37h14.174zm-6.144 2.03h6.088v11.666h-6.086L15.012 11.4zm-8.115 0v11.666h6.087V11.4H6.898z" />
      <path d="M13.454 3.084a1.522 1.522 0 011.602.017l10.14 6.426a1.014 1.014 0 01-.544 1.873H23.13v11.666h1.43a.6.6 0 01.6.6v.83a.6.6 0 01-.6.6H3.44a.6.6 0 01-.6-.6v-.829a.6.6 0 01.6-.6h1.43V11.398H3.348a1.016 1.016 0 01-.525-1.883l10.63-6.431zM4.27 11.998h-.922a1.617 1.617 0 01-1.5-2.21c.13-.327.363-.603.664-.786L13.143 2.57a2.123 2.123 0 012.072-.069h.016L25.515 9.02a1.615 1.615 0 01-.864 2.98M4.27 11.997v10.47h-.83a1.2 1.2 0 00-1.2 1.2v.828a1.2 1.2 0 001.2 1.2h21.12a1.2 1.2 0 001.2-1.2v-.83a1.2 1.2 0 00-1.2-1.2h-.83V12h.92M14.237 4.983L6.984 9.37h14.173l-6.921-4.387zM19.09 8.77l-4.862-3.081-5.093 3.08h9.955zm-4.076 2.63H21.1v11.666h-6.086L15.014 11.4zm.6 11.066h4.887V12h-4.887v10.467zm-8.716.6V11.4h6.087v11.666H6.898zm5.487-.6V12H7.498v10.467h4.887z" />
    </g>
  </svg>
)
